export { default as messages } from './messages';

export const ZZ_LINE_CODE = 'ZZ';
